export default [
    {
        name: 'Projetos',
        url: '/sgtec/gestores/projetos',
        icon: 'fa fa-book',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        },
        regras: 'SGTEC-GEST-PRJ-00'
    },
    {
        name: 'Pagamentos',
        url: '/sgtec/gestores/pagamentos',
        icon: 'fa fa-dollar',
        badge: {
            variant: 'primary',
            text: 'GESTOR'
        },
        regras: 'SGTEC-GEST-PAG-00'
    },
    {
        name: 'Paineis',
        url: '/sgtec/gestores/paineis',
        icon: 'fa fa-file',
        regras: ['SGTEC-GEST-PNL-00'],
        children: [
            {
                name: 'Comprom. com Erro',
                url: '/sgtec/gestores/paineis/erroscomprometimentos',
                icon: 'fa fa-exclamation-circle',
                regras: 'SGTEC-GEST-PNL-01'
            }
        ]
    }
]
